export const profile = {
  Verified: 'Verifizierter Entwickler',
  'Experience years': '7 Jahre Erfahrung',
  'Minutes on spotify': '83.194 Minuten auf Spotify (2024)',
  'About me': 'Über mich',
  'About me description': `🚀 Senior Software Engineer 🚀

👨‍💻 Senior Software Engineer mit 7 Jahren Erfahrung in der Entwicklung von Web- und Mobile-Anwendungen.

📍 Ansässig in Buenos Aires, Argentinien.

💼 Derzeit spezialisiert auf Typescript-Projekte, die sowohl Frontend- (React.js) als auch Backend-Entwicklung (Node.js) abdecken, mit Erfahrung in der Mobile-Entwicklung (React Native / Ionic / Expo). Zusätzlich habe ich mit anderen Programmiersprachen wie Python und PHP gearbeitet.

⚙️ Leidenschaftlich für Automatisierung und kontinuierliche Verbesserung, hatte ich auch die Gelegenheit, an DevOps-Aufgaben zu arbeiten, Prozesse zu optimieren und Effizienz im Software-Entwicklungslebenszyklus sicherzustellen.

🔍 Immer auf der Suche nach neuen Herausforderungen und Gelegenheiten, meine technischen Fähigkeiten und Leidenschaft für Technologie in dynamischen und kollaborativen Umgebungen anzuwenden.
    `,
  'Download CV': 'CV herunterladen',
};
